import { i18n } from "@lingui/core";
import { I18nProvider } from "@lingui/react";
import { hydrate } from "../hydrate.tsx";
import {
	CreateItemButton,
	CreateItemButtonProps,
} from "./create-item-button.tsx";

hydrate("create-item-button-island", (props: CreateItemButtonProps) => (
	<I18nProvider i18n={i18n}>
		<CreateItemButton {...props} />
	</I18nProvider>
));
